"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Keys;
(function (Keys) {
    Keys[Keys["up"] = 38] = "up";
    Keys[Keys["down"] = 40] = "down";
    Keys[Keys["return"] = 13] = "return";
    Keys[Keys["escape"] = 27] = "escape";
    Keys[Keys["left"] = 37] = "left";
    Keys[Keys["right"] = 39] = "right";
})(Keys = exports.Keys || (exports.Keys = {}));
//# sourceMappingURL=keys.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swimlane/ngx-datatable/release/utils/keys.js
// module id = Qp6t
// module chunks = 1